const getters = {
  getJobs: state => state.jobs,
  getTotalJob: state => state.totalJob,
  getJobsCategory: state => state.jobsCategory,
  getJobListCity: state => state.listJobCity,
  getJobListNeighborhood: state => state.listJobNeighborhood,
  getJobProfileVideo: state => state.jobProfileVideo,
  getJobsAlert: state => state.jobsAlert,
  getTotalJobsAlert: state => state.totalJobsAlert,
  getListJobsPending: state => state.listJobsPending,
  getJobAlertSettings: state => state.jobAlertSettings,
  getListInterestedTalents: state => state.listInterestedTalents,
  getTotalInterestedTalent: state => state.totalInterestedTalent,
  getListJoinedTalents: state => state.listJoinedTalents,
  getTotalJoinedTalent: state => state.totalJoinedTalent,
  getListWaitForConfirmationTalents: state => state.listWaitForConfirmationTalents,
  getTotalWaitForConfirmationTalent: state => state.totalWaitForConfirmationTalent,
  getListOtherTopRatedTalents: state => state.listOtherTopRatedTalents,
  getTotalOtherTopRatedTalent: state => state.totalOtherTopRatedTalent
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/jobs/getters.js